import { RadioField } from '@openx/components-core/lib/RadioField/RadioField.tsx';
import type { Option } from '@openx/types/options.ts';

type RadioSelectorProps = {
  selectedOptions: string | undefined;
  onOptionChange: (options: string) => void;
  isDisabled?: boolean;
  options?: Option[];
  orientation?: 'row' | 'column';
  defaultOption?: string;
};

export const RadioSelector = ({
  options,
  selectedOptions,
  onOptionChange,
  isDisabled,
  orientation = 'column',
  defaultOption,
}: RadioSelectorProps) => {
  const defaultOptionElement = { label: defaultOption ?? '', value: '', tooltip: undefined };
  const radioOptions =
    options?.map(option => ({ label: option.name, value: option.id, tooltip: option.tooltip })) ?? [];

  return (
    <RadioField
      sx={{ alignItems: 'flex-start', gap: 1, flexDirection: orientation }}
      value={selectedOptions ? selectedOptions : defaultOptionElement.value}
      options={defaultOption ? [defaultOptionElement, ...radioOptions] : radioOptions}
      onChange={e => onOptionChange(e.target.value)}
      isDisabled={isDisabled}
    />
  );
};
